import { css } from 'styled-components';

const medium = () => css`
  height: 32px;
  padding: 10px 12px 9px 12px;
`;

export { medium };
